import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  isLoading = false;
  labelText = 'Welcome to the Cognos Controller';
  constructor(private readonly router: Router, private readonly authService: AuthService) { }

  ngOnInit(): void {
    const account = this.authService.activeAccount;

    if (!account) {
      this.authService.login();
    }
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }
  goToSearch(): void {
    this.router.navigate(['/search']);
  }
}
